/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { CustomerPickupTimeFragment } from './cartPickupTimeFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartUpdatePickupTimeMutationVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
  pickupTime: Types.Scalars['DateTime']
}>

export type CartUpdatePickupTimeMutation = {
  __typename: 'Root'
  cartUpdatePickupTime: {
    __typename: 'CartUpdatePickupTimePayload'
    cart: {
      __typename: 'Cart'
      id: number | null
      delayedPickupAt: any | null
      pickupTimeSelected: boolean
    } | null
    errors: Array<{
      __typename: 'UserError'
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CartUpdatePickupTimeMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cartUpdatePickupTimeMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pickupTime' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DateTime' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartUpdatePickupTime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pickupTime' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pickupTime' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'customerPickupTimeFragment'
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    ...CustomerPickupTimeFragment.definitions
  ]
} as unknown as DocumentNode
export type CartUpdatePickupTimeMutationMutationFn = Apollo.MutationFunction<
  CartUpdatePickupTimeMutation,
  CartUpdatePickupTimeMutationVariables
>

/**
 * __useCartUpdatePickupTimeMutation__
 *
 * To run a mutation, you first call `useCartUpdatePickupTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartUpdatePickupTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartUpdatePickupTimeMutation, { data, loading, error }] = useCartUpdatePickupTimeMutation({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *      pickupTime: // value for 'pickupTime'
 *   },
 * });
 */
export function useCartUpdatePickupTimeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartUpdatePickupTimeMutation,
    CartUpdatePickupTimeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CartUpdatePickupTimeMutation,
    CartUpdatePickupTimeMutationVariables
  >(CartUpdatePickupTimeMutationDocument, options)
}
export type CartUpdatePickupTimeMutationHookResult = ReturnType<
  typeof useCartUpdatePickupTimeMutation
>
export type CartUpdatePickupTimeMutationMutationResult =
  Apollo.MutationResult<CartUpdatePickupTimeMutation>
export type CartUpdatePickupTimeMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CartUpdatePickupTimeMutation,
    CartUpdatePickupTimeMutationVariables
  >
